@if (toasts().length > 0) {
  <div class="toast-container">
    @for (toast of toasts(); track toast.id) {
      <lib-toast [toast]="toast" />
    }
  </div>
}

